<template>
  <div class="identification">
    <div class="flexBox">
      <div class="left">
        <el-upload
          drag
          action="/api/upload/upload"
          name="file"
          multiple
          accept="image/jpeg,image/gif,image/png"
          :http-request="upload"
          :show-file-list="false"
          ref="uploadId"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将身份证拖到此处，或 <em>点击上传</em>
          </div>
        </el-upload>
        <div class="textbox">
          <div class="top">
            <el-scrollbar>
              <div v-for="(item, index) in tableData" :key="index">
                <p>姓名：{{ item.name }}</p>
                <p>性别：{{ item.sex }}</p>
                <p>民族：{{ item.nation }}</p>
                <p>出生：{{ item.birth }}</p>
                <p>住址：{{ item.address }}</p>
                <p>公民身份证号：{{ item.idCardNum }}</p>
              </div>
            </el-scrollbar>
          </div>
          <div class="botttom">
            <p>识别成功（{{ tableData.length }}）</p>
            <p>上传中（{{ plan }}）</p>
            <p>识别失败（{{ fail }}）</p>
          </div>
        </div>
      </div>
      <div class="right">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="380"
          size="mini"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="100" align="center">
          </el-table-column>
          <el-table-column prop="idCardNum" label="身份证" align="center">
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="60" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="dele(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="danger" size="small" @click="dele()"
          >清空表格</el-button
        >
      </div>
    </div>
    <el-button type="primary" size="small" @click="ok()">确定</el-button>
  </div>
</template>
<script>
import { idCardIdentification, upload } from "@/api/public";
import compressImg from "@/utils/compressImg";
import verify from "@/utils/verify";
export default {
  name: "identification",
  props: {
    visible: {
      typr: Boolean,
      required: true
    }
  },
  data() {
    return {
      plan: 0,
      fail: 0,
      tableData: []
    };
  },
  mounted() {
    console.log(this.visible);
  },
  methods: {
    //上传
    upload(e) {
      console.log(e);
      let that = this;
      let form = new FormData();
      that.plan++;
      compressImg(e.file).then(function(e) {
        form.append("file", e);
        form.append("folder", "idCard");
        upload(form).then(function(e) {
          console.log(e);
          idCardIdentification({ idCard: e.data.fileUrl, idCardSide: "front" })
            .then(function(res) {
              console.log(res);
              that.plan--;
              if (res.code == 1) {
                if (res.data.idcard_number_type == 1) {
                  let _data = {
                    name: res.data.words_result["姓名"].words,
                    sex: res.data.words_result["性别"].words,
                    nation: res.data.words_result["民族"].words,
                    birth: res.data.words_result["出生"].words,
                    address: res.data.words_result["住址"].words,
                    idCardNum: res.data.words_result["公民身份号码"].words
                  };
                  _data.age = verify.getAge(
                    res.data.words_result["公民身份号码"].words
                  );
                  that.tableData.push(_data);
                } else {
                  that.fail++;
                }
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        });
      });
    },
    //上传删除
    dele(e) {
      console.log(e);
      if (e) {
        this.tableData.splice(e, 1);
      } else {
        this.tableData = [];
      }
    },
    // 确定
    ok(e) {
      this.$emit("update:visible", false);
      this.$emit("change", this.tableData);
      this.plan = 0;
      this.fail = 0;
      this.tableData = [];
      console.log(this.$refs.uploadId);
      this.$refs.uploadId.abort();
    }
  }
};
</script>
<style lang="scss">
.identification {
  text-align: center;
  .flexBox {
    display: flex;
    justify-content: space-between;
    text-align: left;
    .left {
      width: 400px;
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 220px;
          .el-icon-upload {
            font-size: 67px;
            color: #c0c4cc;
            margin: 60px 0 16px;
          }
        }
      }
      .textbox {
        margin-top: 25px;
        border: 1px solid #d8e5ff;
        .el-scrollbar {
          height: 100%;
          .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        .top {
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 10px;
          height: 150px;
          overflow: hidden;
          p {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            margin: 0 0 3px;
          }
        }
        .botttom {
          border-top: 2px solid #e9e9e9;
          padding: 15px 10px;
          p {
            font-size: 12px;
            font-weight: 500;
            color: #4eb77e;
            line-height: 17px;
            margin: 0;
          }
          p + p {
            margin-top: 10px;
          }
          p:nth-child(2) {
            color: #b69308;
          }
          p:nth-child(3) {
            color: #e74c3c;
          }
        }
      }
    }
    .right {
      flex: 1;
      margin-left: 15px;
      border: 1px solid #eceef5;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .el-table {
        max-height: 380px;
        thead {
          th + th div {
            border-left: 1px solid #d6d6d8;
          }
        }
        .el-button--mini {
          padding: 3px 10px;
        }
      }
      // & > .el-button {
      //   margin-bottom: 15px;
      // }
    }
  }
  & > .el-button {
    margin-top: 50px;
  }
}
</style>
